import { useMemo, memo } from 'react';

import CasinoSection from '@/features/v2/home/components/CasinoSection/CasinoSection';

import { CasinoSectionType } from '@/features/v2/home/components/CasinoSection/enums';
import instanceId from '@/features/v2/home/components/CasinoSection/intance';
import { CasinoGame } from '@/features/v2/home/components/CasinoSection/interface';

import { useAuth } from '@/core/auth/client/AuthProvider';

import Bonus from './components/Bonus';
import LiveBets from './components/LiveBets';

const FirstView = memo(({
  initialCasinoGames,
  initialZingaGames,
}: {
  initialCasinoGames?: CasinoGame[];
  initialZingaGames?: CasinoGame[];
}) => {
  const { session } = useAuth();

  const type = useMemo(() => {
    return session?.user ? CasinoSectionType.ZINGA : CasinoSectionType.CASINO;
  }, [session?.user]);

  return (
    <div>
      <Bonus />
      <CasinoSection
        type={type}
        showLink={false}
        instanceId={instanceId.HOME_ZINGA}
        initialGames={type === CasinoSectionType.ZINGA ? initialZingaGames : initialCasinoGames}
      />
      <LiveBets />
      {session && <CasinoSection type={CasinoSectionType.FAVORITES} showLink={false} instanceId={instanceId.HOME_FAVORITES} />}
    </div>
  );
});

FirstView.displayName = 'FirstView';

export default FirstView;
